import { render, staticRenderFns } from "./CarDocumentEditForm.vue?vue&type=template&id=4fc4a0c8&scoped=true&"
import script from "./CarDocumentEditForm.vue?vue&type=script&lang=js&"
export * from "./CarDocumentEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CarDocumentEditForm.vue?vue&type=style&index=0&id=4fc4a0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4a0c8",
  null
  
)

export default component.exports